import React from 'react';
import { DotsThreeVertical } from 'phosphor-react';
import { Menu } from '../../';
import * as Styled from './Card.styles';
export var CardTypes;
(function (CardTypes) {
    CardTypes["Normal"] = "Normal";
    CardTypes["Subtle"] = "Subtle";
    CardTypes["Inverted"] = "Inverted";
})(CardTypes || (CardTypes = {}));
export const Card = ({ children, menu, type, showOverflow }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React.createElement(Styled.Wrapper, { "$type": type, "$showOverflow": showOverflow },
        menu && (React.createElement(React.Fragment, null,
            React.createElement(Styled.Menu, { id: "menu-button", "aria-controls": open ? 'menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick },
                React.createElement(DotsThreeVertical, { size: 24 })),
            React.createElement(Menu, { id: "menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'menu-button',
                }, anchorOrigin: { horizontal: 'right', vertical: 'top' }, transformOrigin: { horizontal: 'right', vertical: 'top' } }, menu))),
        children));
};
export default Card;
